/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { useRoleByProjectLazyQuery } from '../../../../../graphql/generated/graphql';

import DashboardNavbar from '../common/navbar';
import DashboardSidebar from './sidebar';
import { setIdCurrentProject } from '../../../../hooks/projectsInfo';
import Loading from '../../../../pages/components/loading';
import { UserTypes } from '../../../../config/enums';
import { setAlertDescription, setOpenAlertMenu, useActionAlertState } from '../../../../hooks/actions';
import { setEditing, useLoginState } from '../../../../hooks/loginInfo';

const DashboardLayoutRoot = styled('section')(({ theme }) => ({
  minWidth: '100vw',
  minHeight: '100vh',
  paddingTop: 70,
  [theme.breakpoints.up('md')]: {
    paddingLeft: 280,
  },
}));

const ConfigAdminProjectLayout = (props: any) => {
  const { children } = props;
  const params = useParams();
  const navigate = useNavigate();
  const action = useActionAlertState();
  const loginState = useLoginState();
  const [havePermission, setHavePermission] = useState(false);
  const currentProject = params.projectId || '';

  const [roleByProject, { data, loading }] = useRoleByProjectLazyQuery();

  useEffect(() => {
    setEditing(false)
    roleByProject({
      variables: {
        project_id: currentProject,
      },
    });
    setIdCurrentProject(currentProject);
  }, []);

  useEffect(() => {
    if (data?.roleByProject) {
      setHavePermission(true)
      if (data.roleByProject.role === UserTypes.PRODUCER || data.roleByProject.role === UserTypes.CREW_MEMBER) {
        setHavePermission(true)
        if (loginState.user_type.get() === UserTypes.PRODUCER) {
          setEditing(true)
        }
      } else {
        setAlertDescription({
          open: true,
          message: "You don't have permissions to view the project",
          severity: 'warning',
        });
        navigate('/');
      }
    }
  }, [data]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      {
        havePermission && (
          <DashboardLayoutRoot>
            <DashboardNavbar onSidebarOpen={() => setOpenAlertMenu(true)} />
            <DashboardSidebar
              onClose={() => setOpenAlertMenu(false)}
              open={action.openMenu.get()}
            />
            <Box
              sx={{
                width: '100%',
                p: 4,
              }}
            >
              {children}
            </Box>
          </DashboardLayoutRoot>
        )
      }
    </>
  );
};

export default ConfigAdminProjectLayout;
